import { createReducer } from '@reduxjs/toolkit';
import isEmpty from 'lodash/isEmpty';

import { SET_SIDEBAR_MENU, TOGGLE_SIDEBAR_MENU } from 'constants/redux-actions';

const initState = {
  open: false,
  data: {},
  available: false,
};

const sidebarMenuReducer = createReducer(initState, {
  [TOGGLE_SIDEBAR_MENU]: (state) => ({ ...state, open: !state.open }),
  [SET_SIDEBAR_MENU]: (_, { payload }) => ({
    data: payload || {},
    available: !isEmpty(payload),
    open: false,
  }),
});

export default sidebarMenuReducer;
